import { t } from "../i18n";

import type { ExcalidrawProps, UIAppState } from "../types";

const LibraryMenuBrowseButton = ({
  libraryReturnUrl,
}: {
  libraryReturnUrl: ExcalidrawProps["libraryReturnUrl"];
  theme: UIAppState["theme"];
  id: string;
}) => {
  const defaultLibraryUrl = new URL(
    "/biblioteca/libraries.onepaper",
    window.location.origin,
  ).toString();
  const href = libraryReturnUrl || defaultLibraryUrl;
  return (
    <a
      className="library-menu-browse-button"
      href={href}
      target="_excalidraw_libraries"
    >
      {t("labels.libraries")}
    </a>
  );
};

export default LibraryMenuBrowseButton;
